import { Meta, Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-tnc',
  standalone: true,
  imports: [],
  templateUrl: './customer-tnc.component.html',
  styleUrl: './customer-tnc.component.scss'
})
export class CustomerTncComponent implements OnInit {

  constructor(private _title: Title, private _meta: Meta) { }

  ngOnInit(): void {
    this._title.setTitle("Terms of Use");
  }
}
